import Head from 'next/head';
import { SpinnerCode } from '@/components/codeHighlights/SpinnerCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Loading-Spinner</title>
      </Head>

      <h1>Loading-Spinner</h1>
      <h2 className="mt-5">Loading spinner</h2>
      <div className="d-flex justify-content-center align-content-center p-7">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>

      <div className="d-flex justify-content-center align-content-center bg-black p-7 bg-opacity-100">
        <div className="spinner-border text-white" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>

      <div className="mt-5">
        <SpinnerCode />
      </div>
    </>
  );
};

export default Page;
